<template>
  <div qaid="pre-season-overview-header">
    <section-header size="xl" variants="dividing">
      <heading qaid="pre-season-overview-heading" level="1" size="xl" v-html="bp('order')" />
      <div class="buttons buttons--right-for-md">
        <trek-link qaid="pre-season-overview-review-submit" button primary small @click="reviewOrder">
          <span v-html="bp('reviewSubmit')" />
        </trek-link>
        <trek-button
          ref="tippybutton"
          v-tippy="{
            html: '#delete-shipment-popover',
            interactive: true,
            reactive: true,
            trigger: 'click',
            placement: 'bottom',
            flip: false,
            sticky: true,
            theme: 'flush',
            zIndex: 0,
          }"
          qaid="pre-season-overview-manage-shipment-details"
          secondary
          small
          icon="expand_more"
          :icon-right="true"
        >
          <span v-html="bp('manageShipment')" />
        </trek-button>

        <div v-cloak id="delete-shipment-popover" class="w-48 z-0">
          <ul class="block-list nav-list text-left">
            <li class="block-list__item py-0">
              <trek-link
                qaid="pre-season-overview-edit-shipment-details"
                @click="editShipment"
                v-html="bp('editShipment')"
              />
            </li>
            <li class="block-list__item py-0">
              <trek-link
                qaid="pre-season-overview-delete-shipment-details"
                @click="deleteShipment"
                v-html="bp('deleteShipment')"
              />
            </li>
          </ul>
        </div>
      </div>
    </section-header>

    <el-dialog
      :visible.sync="dialogVisible"
      :title="bp('deleteShipmentDialogText')"
      :center="true"
      :modal="true"
      :modal-append-to-body="false"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :z-index="1000"
    >
      <template slot="footer">
        <div class="buttons buttons--center">
          <trek-button
            alert
            qaid="pre-season-overview-confirm-delete-shipment"
            @click.stop="confirmDeleteShipment"
            v-html="bp('deleteConfirmText')"
          />
          <trek-button
            secondary
            qaid="pre-season-overview-cancel-delete-shipment"
            @click.stop="closeDialog"
            v-html="bp('deleteCancelText')"
          />
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import SectionHeader from '@/components/SectionHeader';
import Heading from '@/components/Heading';
import TrekLink from '@/components/TrekLink';
import {mapState, mapGetters, mapMutations} from 'vuex';
import TrekButton from '@/components/TrekButton';

export default {
  name: 'PreSeasonOverviewHeader',
  components: {Heading, SectionHeader, TrekLink, TrekButton},
  props: {
    orderFormType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  computed: {
    ...mapGetters('preSeason', ['successOnOverview']),
    ...mapState('backend', ['encodedContextPath']),
  },
  mounted() {
    this.initializeOverview();
  },
  methods: {
    initializeOverview() {
      if (this.successOnOverview) {
        this.$notify({
          type: 'success',
          message: this.bp('saveShipmentSuccess'),
        });
        this.showSuccessOnOverview(false);
      }
    },
    reviewOrder() {
      window.location = `${this.encodedContextPath}/pre-season-orders/review/${this.orderFormType}`;
    },
    editShipment() {
      window.location = `${this.encodedContextPath}/pre-season-orders/shipments/${this.orderFormType}`;
    },
    deleteShipment() {
      this.dialogVisible = true;
      if (this.$refs.tippybutton && this.$refs.tippybutton.$el._tippy) {
        this.$refs.tippybutton.$el._tippy.hide();
      }
    },
    confirmDeleteShipment() {
      this.dialogVisible = false;
      axios
        .get(`/pre-season-orders-api/deletePreSeasonOrder/${this.orderFormType}/`)
        .then((response) => {
          if (response.data.meta.feedback.type === 'success') {
            this.showSuccessOnPreSeasonOrders(true);
            window.location = `${this.encodedContextPath}/pre-season-orders/`;
          }
        })
        .catch((error) => {
          this.$notify({
            type: 'alert',
            message: this.bp('deleteFailToast'),
          });
          console.error(error);
        });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    ...mapMutations('preSeason', ['showSuccessOnPreSeasonOrders', 'showSuccessOnOverview']),
  },
};
</script>
